export const isSysAdminSelector = (state) => state?.profile?.isSysAdmin;
export const isFuncAdminSelector = (state) =>
  state?.profile?.isFuncAdmin || state?.profile?.isSysAdmin;
